module.exports = __webpack_public_path__ + "static/img/blockTime.8ccc37d4.png";